import { Auth0ContextInterface } from '@auth0/auth0-react'

let auth0Instance: Auth0ContextInterface | null = null

export function initializeAuth0Instance(instance: Auth0ContextInterface) {
    auth0Instance = instance
}

export async function getTokenOrRedirect(): Promise<string> {
    if (!auth0Instance) {
        throw new Error('Auth0 instance not initialized')
    }

    try {
        // Attempt to get the token silently
        const token = await auth0Instance.getAccessTokenSilently()
        return token
    } catch (error: any) {
        if (
            error.error === 'login_required' ||
            error.error === 'consent_required'
        ) {
            // Redirect to login page if token cannot be retrieved
            await auth0Instance.loginWithRedirect({
                appState: {
                    // make sure the user is forwarded back to the current page (including query string params) after login
                    returnTo: window.location.pathname + window.location.search,
                },
            })
        } else {
            throw error
        }
    }

    // This return is here to satisfy TypeScript; it will never execute
    throw new Error('Unable to retrieve token or redirect user')
}
